import {
    SET_EVENTS_LOADING,
    SET_EVENTS_ERROR,
    FETCH_EVENTS_SUCCESS,
    FETCH_EVENTS_FAIL,
    CREATE_EVENT_FAIL,
    UPDATE_EVENT_FAIL,
    DELETE_EVENT_SUCCESS,
    DELETE_EVENT_FAIL,
    CANCEL_EVENT_SUCCESS,
    CANCEL_EVENT_FAIL,
    REPLANIFY_EVENT_SUCCESS,
    REPLANIFY_EVENT_FAIL,
    DUPLICATE_EVENT_SUCCESS,
    DUPLICATE_EVENT_FAIL,
    EXPORT_BUDGET_FAIL,
    EXPORT_FORMATIONS_FAIL, IMPORT_EVENTS_EXCEL_REQUEST, IMPORT_EVENTS_EXCEL_SUCCESS, IMPORT_EVENTS_EXCEL_FAIL, SEND_EVENT_CALENDAR_FAIL, SEND_EVENT_CALENDAR_SUCCESS, DOWNLOAD_EVENT_ATTENDANCE_SHEET_FAIL, DOWNLOAD_EVENT_ATTENDANCE_SHEET_SUCCESS,
} from "../actions/eventsActions";

const initialState = {
    loading: false,
    error:   null,
    events:  [],
    importResult: null,
    invitationResult: null,

};

const upsertEvent = (list, updated) => {
    const exists = list.some((e) => e.id === updated.id);
    if (exists) return list.map((e) => (e.id === updated.id ? updated : e));
    return [updated, ...list]; // duplicate: nouvel event en tête
};

export default function eventsReducer(state = initialState, action) {
    switch (action.type) {
        case SET_EVENTS_LOADING:
            return { ...state, loading: action.payload };
        case SET_EVENTS_ERROR:
            return { ...state, error: action.payload };
        case FETCH_EVENTS_SUCCESS:
            return { ...state, events: action.payload || [], error: null };

        case IMPORT_EVENTS_EXCEL_REQUEST:
            return { ...state, importResult: null };

        case IMPORT_EVENTS_EXCEL_SUCCESS:
            return { ...state, importResult: action.payload };

        case IMPORT_EVENTS_EXCEL_FAIL:
            return { ...state, importResult: null };
        case SEND_EVENT_CALENDAR_SUCCESS:
            return { ...state, invitationResult: action.payload, error: null };
        case DOWNLOAD_EVENT_ATTENDANCE_SHEET_SUCCESS:
            return { ...state, error: null };

        case DELETE_EVENT_SUCCESS:
            return { ...state, events: state.events.filter((e) => e.id !== action.payload), error: null };
        case CANCEL_EVENT_SUCCESS:
        case REPLANIFY_EVENT_SUCCESS:
        case DUPLICATE_EVENT_SUCCESS:
            return { ...state, events: upsertEvent(state.events, action.payload), error: null };
        case FETCH_EVENTS_FAIL:
        case CREATE_EVENT_FAIL:
        case UPDATE_EVENT_FAIL:
        case DELETE_EVENT_FAIL:
        case CANCEL_EVENT_FAIL:
        case REPLANIFY_EVENT_FAIL:
        case DUPLICATE_EVENT_FAIL:
        case EXPORT_BUDGET_FAIL:
        case EXPORT_FORMATIONS_FAIL:
        case SEND_EVENT_CALENDAR_FAIL:
        case DOWNLOAD_EVENT_ATTENDANCE_SHEET_FAIL:
            return { ...state, error: action.payload };
        default:
            return state;
    }
}
